export const NOTIFICATION_MSG_REPORTS = {
  NOTIFICATION_SETTINGS_UPDATED: 'Notification Settings have been updated.',
  ENCOUNTERED_ERROR_ON_TOKEN_FETCH:
    'Encountered an error while fetching a token.',
  MOBILE_NO_NOT_UPDATED:
    'Mobile number not updated. Please try after some time',
  PLEASE_TRY_AGAIN_AFTER_SOMETIME: 'Please try again after some time.',
  NO_REPORTS: 'No reports available',
  ENCOUNTERED_ERROR_ON_REPORTS: 'Encountered an error while fetching reports.',
  ENCOUNTERED_ERROR_ON_POLICY_DETAILS:
    'Encountered an error while fetching policy details.',
}

export const OTP_SENT_SUCCESSFULLY = 'OTP has been resent successfully.'

export const OTP_FAILED = 'OTP resend failed. Please try again.'
